import AccountDetailsPage, { getDefaultPageUI, getDefaultPageData } from "components/pages/AccountDetailsPage";
import { BCMSStateManagerCRUD, useBCMSContext, BCMSRecord, BCMSCurrency } from "bcms-react";
import Classes from "model";

export default function CaptureAccountsSearchResults(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "searchCriteria", "isActive" ], true)
        .update(["searchClearSearchButton", "isActive"], true)
        .submit();

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "submittedSearch", "amount" ], BCMSCurrency.init("10"))
        .update([ "submittedSearch", "check" ], "2312")
        .update([ "search", "amount" ], BCMSCurrency.init("10"))
        .update([ "search", "check" ], "2312")
        .submit(); 
 
    data.transactions = data.search.filter();

    return <AccountDetailsPage ui={ ui } data={ data } />
}